import { apiSlice } from '../Slices/apiSlice';

export const productService = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getProductsById: builder.query({
      query: (productId) => `/filter-management/product-details/${productId}`,
      providesTags: ["item"]
    }),

    getAllProducts: builder.query({
      query: () => "/product-management/managed-product",
    }),

    getRecentlyAddedProducts: builder.query({
      query: () => "/product-management/get-recently-added-products",
    }),

    getRelatedProducts: builder.query({
      query: (productId) => `/product-management/get-related-items/${productId}`,
    }),

    getFilteredProducts: builder.mutation({
      query: (filterObject) => ({
        url: '/product-management/search-products',
        method: 'POST',
        body: filterObject
      }),
    }),

    getAllSearchedProducts: builder.query({
      query: (searchParams) => {
        return `/product-management/search-products${searchParams}`;
      },
    }),

    getSearchedProductsByCode: builder.query({
      query: (searchParams) =>
        `/product-management/search-products/by-code${searchParams}`,
    }),

  })
});

export const { 
  useGetProductsByIdQuery,
  useLazyGetProductsByIdQuery,
  useGetAllProductsQuery,
  useGetRecentlyAddedProductsQuery,
  useGetRelatedProductsQuery,
  useGetFilteredProductsMutation,
  useLazyGetAllSearchedProductsQuery,
  useLazyGetSearchedProductsByCodeQuery,
  // util: { getRunningQueriesThunk },
} = productService;

export const { 
  getProductsById,
  getFilteredProducts,
  getAllSearchedProducts,
  getSearchedProductsByCode
} = productService.endpoints;